module.exports = __webpack_public_path__ + "static/media/outline-icons.82f60bd0.svg";